import axios, { AxiosError } from 'axios';

export const extractError = (e: Error | AxiosError) => {
  if (axios.isAxiosError(e) && e.response?.data) {
    const data = e.response.data as { message?: unknown; error?: unknown };
    const raw = data.message ?? data.error;
    const message = typeof raw === 'string' ? raw : JSON.stringify(raw);
    if (message) {
      throw new Error(message);
    }
  }
  throw e;
};
